import SplitType from "split-type";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const init = (textContainer) => {
  const text = new SplitType(textContainer, { types: ["words", "chars"] });

  gsap.fromTo(
    text.chars,
    {
      color: textContainer.dataset.textFillAnimationFromColor,
    },
    {
      color: textContainer.dataset.textFillAnimationToColor,
      duration: 0.3,
      stagger: 0.02,
      scrollTrigger: {
        trigger: textContainer,
        start: "top 80%",
        end: "top 20%",
        scrub: true,
        markers: false,
        toggleActions: "play play reverse reverse",
      },
    }
  );
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const textContainers = document.querySelectorAll("[data-text-fill-animation]");

    textContainers?.forEach(init);
  },
  {
    once: true,
  }
);
